import moment from "moment";
import Constants from "../../utils/constants";
import BaseUserService from "../BaseUserService";
import DateUtils from "../../utils/DateUtils";

const path = 'user-day';
export default class ReportedUserDayService extends BaseUserService {
    // Initializing important variables
    constructor() {
        super(path);
        this.path = path;
    }
    getCriteria(criteria) {
        return this.objToQueryString({
            selectedDay: moment(criteria.selectedDay).format(Constants.DATE_GET_REQUEST_FORMAT)
        });
    }

    get(day, projectId, userId) {
        const formattedDate = moment(day).format(Constants.DATE_GET_REQUEST_FORMAT)
        return this.fetch(`${this.domain}/${this.path}/events?day=${formattedDate}&projectId=${projectId}&userId=${userId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    normalizeTime(element) {
        const formattedUserTime = moment(element.userTime).format('yyyy-MM-DD HH:mm');
        const formattedTimeFrom = moment(element.timeFrom).format('yyyy-MM-DD HH:mm');
        const formattedTimeTo = moment(element.timeTo).format('yyyy-MM-DD HH:mm');
        const formattedCreativeTime = moment(element.creativeTime).format('yyyy-MM-DD HH:mm');

        element.userTime = element.userTime && DateUtils.isValidDate(element.userTime) ? formattedUserTime : null
        element.timeFrom = element.timeFrom && DateUtils.isValidDate(element.timeFrom) ? formattedTimeFrom : null
        element.timeTo = element.timeTo && DateUtils.isValidDate(element.timeTo) ? formattedTimeTo : null
        element.creativeTime = element.creativeTime && DateUtils.isValidDate(element.creativeTime) ? formattedCreativeTime : null
    }


    keepOnlyId(obj) {
        return {
            id: obj.id
        };
    }

    normalizeElement(element, day) {
        element.events.forEach((element) => {
            this.normalizeTime(element.event);
            element.event.selectedDay = moment(day).format(Constants.DATE_JSON_FORMAT);
        });
        return element
    }

    update(element, userId) {
        // Get a token from api server using the fetch api
        element.day = moment(element.day).format(Constants.DATE_GET_REQUEST_FORMAT)
        const e = this.normalizeElement(this.cloneElement(element), element.day);
        return this.fetch(`${this.domain}/${this.path}/${userId}`, {
            method: 'PUT',
            body: JSON.stringify(e),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    approve(day, projectId, userId) {
        return this.fetch(`${this.domain}/${this.path}/approve?day=${day}&projectId=${projectId}&userId=${userId}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    open(day, projectId, userId) {
        return this.fetch(`${this.domain}/${this.path}/open?day=${day}&projectId=${projectId}&userId=${userId}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    reject(day, projectId, rejectReason, userId) {
        return this.fetch(`${this.domain}/${this.path}/reject?day=${day}&projectId=${projectId}&rejectReason=${rejectReason}&userId=${userId}`, {
            method: 'POST',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getCreateUserDayRequestModel(element) {
        element.day = moment(element.day).format(Constants.DATE_GET_REQUEST_FORMAT)
        const user = element.user;
        element.user = {
            id: user.id,
        }
        element.events.forEach((x) => {
            const formattedUserTime = x.event.userTime && moment(x.event.userTime).isValid() ? moment(x.event.userTime).format('HH:mm') : null;
            const formattedTimeFrom = x.event.timeFrom && moment(x.event.timeFrom).isValid() ? moment(x.event.timeFrom).format('HH:mm') : null
            const formattedTimeTo = x.event.timeTo && moment(x.event.timeTo).isValid() ? moment(x.event.timeTo).format('HH:mm') : null;
            const formattedCreativeTime = x.event.creativeTime && moment(x.event.creativeTime).isValid() ? moment(x.event.creativeTime).format('HH:mm') : null;

            x.event.userTime = formattedUserTime;
            x.event.timeFrom = formattedTimeFrom;
            x.event.timeTo = formattedTimeTo;
            x.event.creativeTime = formattedCreativeTime
        })
        return element
    }

    addNewUserDay(element) {
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'POST',
            body: JSON.stringify(this.getCreateUserDayRequestModel(this.cloneElement(element)))
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    remove(element) {
        return this.fetch(`${this.domain}/${this.path}/${element.id}?date=${moment(element.date).format(Constants.DATE_GET_REQUEST_FORMAT)}&projectId=${element.projectId}`, {
            method: 'DELETE',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
